import { getOptionalSelectValue } from "./getOptionalSelectValue";
import * as yup from "yup";

const acceptedProfessions = [
    "STUDENT",
    "RETIRED",
    "UNEMPLOYED",
    "HOMEMAKER",
    "ENTREPRENEUR",
    "FREELANCER",
    "PUBLIC_SECTOR_MANAGER",
    "PRIVATE_SECTOR_MANAGER",
    "FUNCTIONARY",
    "OFFICE_WORKER",
    "SPECIALIZED_LABORER",
    "LABORER",
    "TECHNICIAN",
    "ARTISAN",
    "FARMER",
    "BREEDER",
    "TEACHER",
    "EDUCATOR",
    "RESEARCHER",
    "ENGINEER",
    "SOCIAL_WORKER",
    "HEALTH_WORKER",
    "CULTURAL_WORKER",
    "ENTERTAINMENT_WORKER",
    "ARTIST",
    "COMMUNICATION_WORKER",
    "MERCHANT",
    "JOURNALIST",
    "RESTAURATEUR",
    "PERSONAL_CARE_WORKER",
    "SECURITY_OFFICER",
    "CONSTRUCTION_WORKER",
    "DRIVER",
    "TRUCKMAN",
    "MILITARY",
    "OTHER"
];

export const mappedProfessions = [
    { value: "STUDENT", label: "Studente/Studentessa" },
    { value: "RETIRED", label: "Pensionato/a" },
    { value: "UNEMPLOYED", label: "Disoccupato/a" },
    { value: "HOMEMAKER", label: "Casalingo/a" },
    { value: "ENTREPRENEUR", label: "Imprenditore/Imprenditrice" },
    { value: "FREELANCER", label: "Libero/a professionista" },
    { value: "PUBLIC_SECTOR_MANAGER", label: "Dirigente settore pubblico" },
    { value: "PRIVATE_SECTOR_MANAGER", label: "Dirigente settore privato" },
    { value: "FUNCTIONARY", label: "Funzionario/a" },
    { value: "OFFICE_WORKER", label: "Impiegato/a" },
    { value: "SPECIALIZED_LABORER", label: "Operaio/a specializzato" },
    { value: "LABORER", label: "Operaio/a" },
    { value: "TECHNICIAN", label: "Tecnico/a" },
    { value: "ARTISAN", label: "Artigiano/a" },
    { value: "FARMER", label: "Agricoltore/Agricoltrice" },
    { value: "BREEDER", label: "Allevatore/Allevatrice" },
    { value: "TEACHER", label: "Docente scolastico/universitario" },
    { value: "EDUCATOR", label: "Educatore/Formatore" },
    { value: "RESEARCHER", label: "Ricercatore/Ricercatrice" },
    { value: "ENGINEER", label: "Ingegnere, Architetto/a" },
    { value: "SOCIAL_WORKER", label: "Operatore sociale" },
    { value: "HEALTH_WORKER", label: "Operatore sanitario" },
    { value: "CULTURAL_WORKER", label: "Operatore culturale" },
    { value: "ENTERTAINMENT_WORKER", label: "Operatore dello spettacolo" },
    { value: "ARTIST", label: "Artista/Musicista" },
    { value: "COMMUNICATION_WORKER", label: "Operatore della comunicazione" },
    { value: "MERCHANT", label: "Commerciante" },
    { value: "JOURNALIST", label: "Giornalista/Addetto stampa" },
    { value: "RESTAURATEUR", label: "Addetto in attività ricettive/ristorazione" },
    { value: "PERSONAL_CARE_WORKER", label: "Addetto nei servizi alla persona" },
    { value: "SECURITY_OFFICER", label: "Addetto nei servizi di sicurezza" },
    { value: "CONSTRUCTION_WORKER", label: "Lavoratore edile" },
    { value: "DRIVER", label: "Conducente di veicoli o macchinari" },
    { value: "TRUCKMAN", label: "Trasportatore/Autotrasportatore" },
    { value: "MILITARY", label: "Addetto delle forze armate" },
    { value: "OTHER", label: "Altro" }
].sort((a, b) => a.value === "OTHER" ? 1 : a.label.localeCompare(b.label));

export function formatSubscriber(subscriber, isUGSActive) {
    if(!isUGSActive === false) {
        delete subscriber.isUGS;
    }

    subscriber.nationality = getOptionalSelectValue(subscriber.nationality);
    subscriber.phone.code = getOptionalSelectValue(subscriber.phone.code);
    subscriber.residenceAddress.country = getOptionalSelectValue(subscriber.residenceAddress.country)
    subscriber.residenceAddress.zip = getOptionalSelectValue(subscriber.residenceAddress.zip);
    subscriber.birthProvince = getOptionalSelectValue(subscriber.birthProvince);

    if(!!subscriber.birthPlace.label) {
        subscriber.birthPlace = subscriber.birthPlace.label;
    }

    if(subscriber.phone.code?.value) {
        subscriber.phone.code = subscriber.phone.code.value
    }

    if(subscriber.residenceAddress.city?.value) {
        subscriber.residenceAddress.city = subscriber.residenceAddress.city.value;
    }

    if(subscriber.residenceAddress.city?.name) {
        subscriber.residenceAddress.city = subscriber.residenceAddress.city.name;
    }

    if(subscriber.residenceAddress.country !== "Italia") {
        delete subscriber.residenceAddress.region;
        delete subscriber.residenceAddress.province;
    }

    delete subscriber.memberships;

    return subscriber;
}

export const membershipValidationSchema  = yup.object().shape({
    groupId: yup.mixed().notRequired(),
    isItaly: yup.boolean().required(),
    paidAmount: yup.number().typeError('Inserisci una somma corretta').min(0, "Inserisci una somma positiva"),
    zips: yup.array(),
    subscriber: yup.object().shape({
        firstName: yup.string().required("Compila il campo"),
        lastName: yup.string().required("Compila il campo"),
        birthPlace: yup.object().typeError("Inserisci il luogo di nascita").required("Inserisci il luogo di nascita"),
        birthProvince: yup.object().typeError("Inserisci la provincia di nascita").required("Inserisci la provincia di nascita"),
        birthDate: yup.date().typeError("Inserisci una data corretta").required("Inserisci un valore"),
        gender: yup.string().oneOf(["MALE", "FEMALE", "OTHER"]),
        email: yup.string().email("Inserisci una mail corretta").required("Compila il campo"),
        nationality: yup.object().required("Compila il campo"),
        fiscalCode: yup.string().required("Compila il campo"),
        profession: yup.string().oneOf(acceptedProfessions, "Scegli una professione").required("Scegli una professione"),
        residenceAddress : yup.object().shape({
            street: yup.string().required("Compila il campo"),
            number: yup.string().required("Compila il campo"),
            secondary: yup.string("Compila il campo"),
            city: yup.lazy(value => {
                switch (typeof value) {
                    case 'string':
                        return yup.string().required("Compila il campo");
                        default:
                    return yup.object().typeError("Compila il campo");
                }
            }),
            region: yup.mixed().required(),
            zip: yup.mixed().transform((v) => !v ? undefined: v).required("Scegli un valore"),
            province: yup.string(),
            country: yup.object().required("Compila il campo"),
        }),
        phone: yup.object().shape({
            code: yup.object().required(),
            number:  yup.string().required("Inserisci il numero di telefono")
        }),
        isUGS: yup.boolean().required()
    })
});

export const membershipsValidationSchema = yup.object().shape({
    memberships: yup.array().of(membershipValidationSchema)
});

export const subscriberValidationSchema = yup.object().shape({
    firstName: yup.string().required("Inserisci un valore"),
    lastName: yup.string().required("Inserisci un valore"),
    birthProvince: yup.object().typeError("Scegli la provincia di nascita").required("Scegli una provincia"),
    birthPlace: yup.object().typeError("Scegli un luogo di nascita").required("Scegli un luogo di nascita"),
    birthDate: yup.date().typeError("Inserisci una data corretta").required("Inserisci un valore"),
    nationality: yup.mixed().required("Scegli una nazionalità"),
    gender: yup.string().oneOf(["MALE", "FEMALE", "OTHER"], "Scegli una delle tre opzioni").required("Scegli un valore"),
    profession: yup.string().oneOf(acceptedProfessions, "Scegli una professione").required("Scegli una professione"),
    fiscalCode: yup.string().required("Inserisci un codice fiscale o generalo utilizzando il pulsante"),
    phone: yup.object().shape({
        code: yup.object().required("Inserisci un valore"),
        number: yup.string().required("Inserisci un valore"),
    }),
    email: yup.string().email("Inserisci una mail corretta").required("Inserisci un valore"),
    residenceAddress : yup.object().shape({
        street: yup.string().required("Inserisci un valore"),
        number: yup.string().required("Inserisci un valore"),
        secondary: yup.string(),
        city: yup.mixed().transform((v) => !v ? undefined: v).required("Scegli un valore"),
        region: yup.mixed(),
        zip: yup.mixed().transform((v) => !v ? undefined: v).required("Scegli un valore"),
        province: yup.mixed(),
        country: yup.object().required("Scegli un valore"),
    }),
    isUGS: yup.boolean().required("Scegli un valore"),
    confirmEmail: yup.string().email("Inserisci una mail corretta"),
    groupId: yup.mixed(),
    membership: yup.object().shape({
        id: yup.string().required(),
        active: yup.boolean().default(false),
        paidAmount: yup.number()
            .when("active", {
                is: (val) => [true, "true"].includes(val),
                then: () => yup.number().typeError("Inserisci un numero").required("Inserisci una somma").required("Inserisci una somma"),
                otherwise: () => yup.number().nullable().optional()
            }),
        paidAt: yup.date()
            .when("active", {
                is: (val) => [true, "true"].includes(val),
                then: () => yup.date().typeError("Inserisci una data corretta").required("Inserisci un valore"),
                otherwise: () => yup.date().nullable().optional()
            }),
        paymentMethod: yup.string().optional().nullable(),
    }).optional().default(undefined)
});

export const groupTypeByAncestorCount = [
    { value: "Mondo", match: (x) => x === 1 },
    { value: "Nazionale", match: (x) => x === 2 },
    { value: "Regionale", match: (x) => x === 3 },
    { value: "Federazione", match: (x) => x === 4 },
    { value: "Circolo", match: (x) => x >= 5 },
];

export function functionGetMembershipByYear(mbs, year) {
    return mbs.find(mb => mb.year === year)
}